import { render } from "./OcrReportHeaderKeywords.vue?vue&type=template&id=55830c11"
import script from "./OcrReportHeaderKeywords.vue?vue&type=script&lang=js"
export * from "./OcrReportHeaderKeywords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__